export default __webpack_public_path__ + "static/media/news-bg.e1b1fcb4.jpg";